import resetPasswordTemplate from './reset/reset-password.html';
import resetConfirmationTemplate from './reset-confirmation/reset-confirmation.html';
import resetPasswordFromKeyTemplate from './reset-from-key/reset-from-key.html';

export default /* @ngInject */ function($routeProvider, configProvider) {
    $routeProvider.when('/password/reset', {
        templateUrl: resetPasswordTemplate,
        controller: 'ResetPasswordCtrl',
        controllerAs: 'reset',
        title: 'Reset your password',
        restrictAuthenticated: false
    });

    $routeProvider.when('/password/reset/key/invalid-token', {
        templateUrl: resetPasswordTemplate,
        controller: 'ResetPasswordCtrl',
        controllerAs: 'reset',
        title: 'Reset your password',
        restrictAuthenticated: false
    });

    $routeProvider.when('/password/reset/confirmation', {
        templateUrl: resetConfirmationTemplate,
        title: 'Email sent',
        restrictAuthenticated: false
    });

    $routeProvider.when('/password/reset/key/:uidb36/:key', {
        templateUrl: resetPasswordFromKeyTemplate,
        controller: 'ResetPasswordFromKeyCtrl',
        controllerAs: 'reset',
        title: 'Choose a new password',
        restrictAuthenticated: false
    });

    $routeProvider.when('/accounts/password/reset/key/8ve-set-password/', {
        templateUrl: resetPasswordFromKeyTemplate,
        title: 'Choose a new password',
        restrictAuthenticated: false
    });

}



// WEBPACK FOOTER //
// ./password/password-routes.js